const container = {
  props: {
    dynamicClass: ".c-container.dynamicLoading",
    cssMaskSelector: "c-mask",
    separatorSelector: ".generic-container.mod--separator",
  },

  init: function (baseDom) {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-container.css", this.props.dynamicClass);

    const baseFind = baseDom ? baseDom : document;

    this.initMasks(baseFind);
    this.initSeparators(baseFind);
  },

  initMasks: function (baseFind) {
    const $elements = baseFind.getElementsByClassName(this.props.cssMaskSelector);

    bcl.u.forEach($elements, this.initMask.bind(this));
  },

  initMask: function ($item) {
    bcl.u.addClass($item.parentNode, "mod--masked");
  },

  initSeparators: function (baseFind) {
    const $elements = baseFind.querySelectorAll(this.props.separatorSelector);

    bcl.u.forEach($elements, this.initSeparator.bind(this));
  },

  initSeparator: function ($container) {
    const $wrapper = $container.children[0].children[0].children[0],
      containerWith = $wrapper.offsetWidth,
      mobile = bcl.u.mobile.isMobile();
    let countWith = 0,
      doubleLine = false,
      $lastNode = null;

    bcl.u.forEach($wrapper.children, ($item) => {
      this.clearItemSeparator($item);

      if (doubleLine) {
        if (countWith === 0) {
          $lastNode = null;
          mobile && bcl.u.removeClass($lastNode, "mod--first");
        }

        bcl.u.addClass($item, "mod--vertical-separator");
      }

      if (bcl.u.containsClass($lastNode, "mod--first")) {
        bcl.u.addClass($item, "mod--last-first");
      }

      let className = "";

      if (countWith === 0) {
        countWith += $item.offsetWidth;
        className = "mod--first";
      } else if (countWith + $item.offsetWidth < containerWith) {
        countWith += $item.offsetWidth;
        className = "mod--med";
      } else {
        countWith = 0;
        doubleLine = true;
        className = "mod--last";

        if (bcl.u.containsClass($lastNode, "mod--last-first")) {
          bcl.u.removeClass($lastNode, "mod--last-first");
        } else {
          bcl.u.addClass($lastNode, "mod--prev-last");
        }
      }

      $lastNode = $item;

      bcl.u.addClass($item, className);
    });
  },

  clearItemSeparator: function ($item) {
    bcl.u.removeClass($item, "mod--first");
    bcl.u.removeClass($item, "mod--med");
    bcl.u.removeClass($item, "mod--last");
    bcl.u.removeClass($item, "mod--vertical-separator");
    bcl.u.removeClass($item, "mod--last-first");
    bcl.u.removeClass($item, "mod--prev-last");
  },
};

export default container;
